import { motion } from 'framer-motion';

const isMobile = typeof window !== 'undefined' && window.innerWidth <= 1024;

const MOTION_PROPS = ['initial', 'animate', 'whileInView', 'whileHover', 'whileTap', 'transition', 'variants', 'viewport'];

function stripMotion(props) {
  const rest = { ...props };
  MOTION_PROPS.forEach(k => delete rest[k]);
  return rest;
}

function make(Tag) {
  return function SafeEl({ children, ...props }) {
    if (isMobile) {
      const safeProps = stripMotion(props);
      return <Tag {...safeProps}>{children}</Tag>;
    }
    const { initial, animate, whileInView, whileHover, whileTap, transition, variants, viewport, ...rest } = props;
    const MotionTag = motion[Tag];
    return (
      <MotionTag
        initial={initial}
        animate={animate}
        whileInView={whileInView}
        whileHover={whileHover}
        whileTap={whileTap}
        transition={transition}
        variants={variants}
        viewport={viewport}
        {...rest}
      >
        {children}
      </MotionTag>
    );
  };
}

// Self-closing elements (no children)
function makeVoid(Tag) {
  return function SafeVoidEl(props) {
    if (isMobile) {
      const safeProps = stripMotion(props);
      return <Tag {...safeProps} />;
    }
    const { initial, animate, whileInView, whileHover, whileTap, transition, variants, viewport, ...rest } = props;
    const MotionTag = motion[Tag];
    return (
      <MotionTag
        initial={initial}
        animate={animate}
        whileInView={whileInView}
        whileHover={whileHover}
        whileTap={whileTap}
        transition={transition}
        variants={variants}
        viewport={viewport}
        {...rest}
      />
    );
  };
}

export const SafeMotion = {
  div: make('div'),
  nav: make('nav'),
  h2: make('h2'),
  h3: make('h3'),
  h4: make('h4'),
  p: make('p'),
  ul: make('ul'),
  li: make('li'),
  span: make('span'),
  blockquote: make('blockquote'),
  img: makeVoid('img'),
};
